import axios from 'axios'
import vm from '../main'
import JSEncrypt from 'jsencrypt'
import qs from 'qs'

const util = {}

// read env from configs file
const env = window['$env'] ? window['$env'] : process.env.NODE_ENV
console.log(env)

// util.baseUrl = env === 'development' ? 'http://121.229.8.137:18087/biyi' : "http://121.229.31.105:18080/biyi"
// util.baseUrl = env === 'development' ? 'http://10.1.95.99:8090' : "http://121.229.31.105:18080/biyi"
// util.baseUrl = env === 'development' ? 'http://121.229.8.137:18081/biyi' : "http://121.229.8.137:18081/biyi"
// util.baseUrl = env === 'development' ? 'http://121.229.8.137:18081/biyitest' : "http://121.229.8.137:18081/biyitest"

// util.baseUrl = env === 'development' ? 'https://lfczhxc.com/biyi' : "http://121.229.8.137:18081/biyitest"
// util.baseUrl = env === 'development' ? 'https://lfczhxc.com/biyi' : "https://lfczhxc.com/biyi"
util.baseUrl = env === 'development' ? 'https://lfczhxc.com/biyi' : "https://lfczhxc.com/biyi"

// 如果前端部署在本地，自动切回本地后端（免手动切换）
// if (location.hostname === 'localhost' || location.hostname === '127.0.0.1' || location.hostname.startsWith('192.168.')) {
//   util.baseUrl = 'http://localhost:8090'
// }

// 将需要外挂文件覆盖的属性写在该函数执行前
loadConfigs()

console.log(util.baseUrl)
util.http = axios.create({
  baseURL: util.baseUrl,
  timeout: 200000
})

// http请求拦截
util.http.interceptors.request.use(function (config) {
  config.headers.Authorization = localStorage.token
  return config
}, function (error) {
  // 请求失败的处理
  return Promise.reject(error)
})

// http响应拦截
util.http.interceptors.response.use(function (res) {
  // 在这里对返回的数据进行处理
  if (!res.config.url.includes('refreshToken')) {
    // 记录ajax调用的时间
    sessionStorage.lastHttpRequestTime = +new Date()
  }
  return res
}, function (error) {
  // Do something with response error
  if (error.response) {
    switch (error.response.status) {
      case 401:
        if (vm.$route.name !== 'login') {
          vm.$Message.warning({
            content: '身份认证信息已失效，请重新登录。',
            duration: 2,
            onClose: () => {
              vm.$router.push({
                name: 'login'
              })
            }
          })
        } else {
          return Promise.reject(error)
        }
        break
      case 403:
        vm.$Message.warning({
          content: error.response.data.message,
          duration: 3
        })
        break
      default:
        return Promise.reject(error)
    }
  } else if (error.message) {
    if (error.message === 'Network Error') {
      vm.$Message.error('网络连接错误，请检查网络环境！')
    } else if (error.message.indexOf('timeout') >= 0) {
      vm.$Message.error('网络连接超时，请重试！')
    } else {
      vm.$Message.error(error.message)
    }
  } else {
    vm.$Message.error('知识盲区的错误，联系程序员小哥哥吧！')
  }
})

/**
 * 将请求参数转换为URLSearchParams格式
 * post、put等，axios默认使用json格式，如果需要使用form格式的，调用该函数进行转换
 * data: object
 */
util.formUrlencoded = function (data) {
  return qs.stringify(data)
}

// 定位新打开的页面在pageOpenedList中位置
util.indexOfCurrentPageOpened = function (name, pageOpenedList) {
  for (let index = 0; index < pageOpenedList.length; index++) {
    if (pageOpenedList[index].name === name) {
      return index
    }
  }
  return -1
}

// 初始化header中的面包屑路径
util.initCurrentPath = function (route, routesTree) {
  if (!(routesTree instanceof Array) || routesTree.length === 0) {
    return []
  }
  if (route.name === 'home') {
    return []
  }
  let res = []
  for (let item of routesTree) {
    if (item.children && item.children.length > 0) {
      const temp = getPathOfChild(route, item.children)
      if (temp.done) {
        res = temp.value
        if (item.type === 'menu') {
          res.splice(0, 0, item.title)
        }
        break
      }
    }
  }
  return res
}

function getPathOfChild(route, sourceArr) {
  let res = {
    value: [],
    done: false
  }
  if (!(sourceArr instanceof Array) || sourceArr.length === 0) {
    return res
  }
  const name = route.name
  for (let item of sourceArr) {
    const temp = []
    temp.push(item.title)
    if (name === item.name) {
      return {
        value: temp,
        done: true
      }
    } else {
      if (item.children && item.children.length > 0) {
        const tempRes = getPathOfChild(route, item.children)
        if (tempRes.done) {
          return {
            value: temp.concat(tempRes.value),
            done: true
          }
        }
      }
    }
  }
  return res
}

// 数据加密方法
const rsaPubKey = ''
util.encryptPassword = function (str) {
  if (rsaPubKey) {
    // 对密码进行加密
    let encryptor = new JSEncrypt() // 新建JSEncrypt对象
    encryptor.setPublicKey(rsaPubKey) // 设置公钥
    return encryptor.encrypt(str) // 加密
  } else {
    return str
  }
}

util.getMenuList = function (menus) {
  const tempList = []
  menus.forEach(ele => {
    if (ele.type && ele.type === 'menu') {
      const tempObj = {}
      if (ele.children) {
        tempObj.children = util.getMenuList(ele.children)
      }
      tempObj.name = ele.name
      tempObj.icon = ele.icon || 'ios-cube-outline'
      tempObj.title = ele.title
      tempList.push(tempObj)
    }
  })
  return tempList
}

util.getMenuRoutes = function (tree) {
  const menuRoutes = buildMenuRoutesStep1(tree)
  buildMenuRoutesStep2(menuRoutes)
  buildMenuRoutesStep3(menuRoutes)
  return menuRoutes
}

function buildMenuRoutesStep1(menus) {
  const tempRoutes = []
  menus.forEach(ele => {
    const tempObj = {}
    if (ele.children) {
      tempObj.children = buildMenuRoutesStep1(ele.children)
    }
    tempObj.path = ele.path
    tempObj.name = ele.name
    tempObj.meta = {
      title: ele.title
    }
    tempObj.component = ele.component
    tempRoutes.push(tempObj)
  })
  return tempRoutes
}

function buildMenuRoutesStep2(routes, root) {
  routes.forEach(ele => {
    if (ele.children) {
      // rootEle保存根节点对象
      const rootEle = root || ele
      buildMenuRoutesStep2(ele.children, rootEle)
      if (JSON.stringify(ele) !== JSON.stringify(rootEle)) {
        if (!ele.component) {
          ele.children.forEach(item => {
            // 将二级菜单的信息放入子路由中
            item.meta.parentName = ele.name
          })
        }
        rootEle.children = rootEle.children.concat(ele.children)
        delete ele.children
      }
    }
  })
}

function buildMenuRoutesStep3(routes) {
  routes.forEach((ele, index) => {
    if (ele.children) {
      buildMenuRoutesStep3(ele.children)
    }
    if (!ele.component) {
      routes.splice(index, 1)
    }
  })
}

function loadConfigs() {
  // load api from config file
  Object.keys(window).forEach(key => {
    if (key.startsWith('$')) {
      if (window[key]) {
        util[key.slice(1)] = window[key]
      }
      delete window[key]
    }
  })
}

//以下为组件所需要引入的函数，4.4.1中没有
//特此说明具体测试待定
util.statistic = function (type, name, childname) {
  let img = new Image();
  img.src = statisticUrl + '?userName=' + userName + '&projectName=' + projectName + '&type=' + type + '&componentName=' + name + '&componentApiName=' + childname + '&count=1' + '&s=' + new Date().getTime();
  var appitem = document.querySelector('#main');
  if (appitem) {
    appitem.appendChild(img);
    appitem.removeChild(img);
  }
}

util.ajaxMethodWidthParams = function (url, method, params) {
  return new Promise((resolver, reject) => {
    var res = resolver;
    util.http({
      method: method,
      url: url,
      data: params
    }).then(response => {
      res(response.data);
    }).catch((error) => {
      reject(error);
    });
  })
};

util.closeRoute = function (vueObject, routeName, nextRouteName) {
  let pageOpenedList = vueObject.$store.state.app.pageOpenedList;
  let lastPageObj = pageOpenedList[0];
  let len = pageOpenedList.length;
  for (let i = 1; i < len; i++) {
    if (pageOpenedList[i].name == routeName) {
      if (i < (len - 1)) {
        lastPageObj = pageOpenedList[i + 1];
      } else {
        lastPageObj = pageOpenedList[i - 1];
      }
      break;
    }
  }

  vueObject.$store.commit('removeTag', routeName);
  vueObject.$store.commit('closePage', routeName);
  pageOpenedList = vueObject.$store.state.app.pageOpenedList;
  localStorage.pageOpenedList = JSON.stringify(pageOpenedList);
  //vueObject.$router.push({ name: nextRoute });
  /**
   * 问题：调用该函数关闭当前页面,无法通过路由传参，导致目标页面无法正确刷新
   * 修改：注释掉代码vueObject.$router.push({ name: nextRoute });
   * 增加以下代码(参考了tag-page-opened.vue的closePage函数)
   */
  for (let i = 1; i < pageOpenedList.length; i++) {
    if (pageOpenedList[i].name == nextRouteName) {
      lastPageObj = pageOpenedList[i];
      break;
    }
  }
  let routerObj = {};
  routerObj.name = lastPageObj.name;
  if (lastPageObj.argu) {
    routerObj.params = lastPageObj.argu;
  }
  if (lastPageObj.query) {
    routerObj.query = lastPageObj.query;
  }
  console.log(routerObj)
  vueObject.$router.push(routerObj);
}

export default util
